import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  CreateHotelCommand,
  IntegratedIReckonHotelDto,
  IntegratedIReckonHotelsService,
  UpdateIReckonHotelDto,
} from '@rocksoft/integrations-ireckon-sdk';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  IReckonIntegratedHotelApiActions,
  IReckonIntegratedHotelContainerActions,
  IReckonIntegratedHotelResolverActions,
} from './integrated-ireckon-hotel.actions';

@Injectable()
export class IReckonHotelEffects {
  private readonly actions$ = inject(Actions);
  private readonly hotelService = inject(IntegratedIReckonHotelsService);

  hotelsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegratedHotelResolverActions.integrationRequested),
      mergeMap(({ locationUniqueId }) =>
        safeMap(
          this.hotelService.getIntegratedIReckonHotels({ hotelCode: undefined, locationUniqueId }),
          (result: IntegratedIReckonHotelDto[]) =>
            IReckonIntegratedHotelApiActions.integrationsLoaded({ hotels: result }),
          (error) => IReckonIntegratedHotelApiActions.integrationsLoadedError({ error })
        )
      )
    );
  });

  hotelUpdatedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegratedHotelContainerActions.integrationUpdated),
      mergeMap(({ hotel }) =>
        hotel.id
          ? safeMap(
              this.hotelService.updateIntegratedIReckonHotel({
                integratedIReckonHotelId: hotel.id,
                updateIReckonHotelDto: {
                  locationUniqueId: hotel.locationUniqueId,
                  hotelCode: hotel.hotelCode,
                } satisfies UpdateIReckonHotelDto,
              }),
              () => IReckonIntegratedHotelApiActions.integrationsUpdated({ hotel }),
              (error) => IReckonIntegratedHotelApiActions.integrationsUpdatedError({ hotel, error })
            )
          : safeMap(
              this.hotelService.addIntegratedIReckonHotel({
                createHotelCommand: {
                  locationUniqueId: hotel.locationUniqueId,
                  hotelCode: hotel.hotelCode,
                } satisfies CreateHotelCommand,
              }),
              (created) => IReckonIntegratedHotelApiActions.integrationsAdded({ hotel: created }),
              (error) => IReckonIntegratedHotelApiActions.integrationsAddedError({ hotel, error })
            )
      )
    );
  });
}
